import React, { Fragment, useState } from "react";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "./../LibSplide/LibSplide.scss";
import api from "api";
import "./index.scss";
import _ from "lodash";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { useEffect } from "react";
import ThreeDots from "component/ThreeDots";
import update from 'immutability-helper';
import { AvatarVertical1 } from "component/Avatar";
import PaginationWrapper from "component/Pagination";
import useMemberList from "hooks/useMembersList";

const MemberCard1 = (props) => {
    const [member, setMember] = useState(props.member);

    const UserButtons = _.filter(props.buttons, (button) => {
        return button.appear.apply(null, [member, button] );
    });

    return (
        <div className="member-card-1">
            <div className="member-wrapper text-center">
                {
                    member.RemoveDate ? <span className="user-delete text-center">User Removed</span> :
                    (
                        member.RejectDate ? <span className="user-delete text-center">
                            <span className="block text-sm mb-sm">{member.UserDisplayName}</span>
                            <span className="block bold">Access Declined</span>
                        </span> : 
                        <Fragment>
                            <AvatarVertical1 user={member}/>
                            {
                                (member.RequiredApproval && !member.ApproveDate) && 
                                <span className="required-action">
                                    Action Needed
                                </span>
                            }
                            {
                                UserButtons.length > 0 && 
                                <ThreeDots>
                                    {
                                        UserButtons.map((button) => 
                                            (
                                                <button key={`user-action-${member.UserID}-${button.key}`} onClick={ (e) => {
                                                    e.preventDefault();

                                                    var ask = window.confirm('Are You Sure ?');

                                                    if(!ask)
                                                    {
                                                        return;
                                                    }
            
                                                    button.action.apply(null, [member, button])
                                                        .then((updatedMember) => {
    
    
                                                            setMember(update(member, {$merge : updatedMember}))
                                                        });
            
                                                }}>{button.label}</button>
                                            )
                                        )
                                    }
                                </ThreeDots>
                            }
                        </Fragment>
                    )
                }
            </div>
        </div>
    )
}

const MemberList = connect(stateMap)((props) => {

    const [parameter, setParameter] = useState( props.membersArgs );

    useEffect(() => {

        setParameter(props.membersArgs);

    }, [props.membersArgs]);

    const {members, total, isLoading} = useMemberList(parameter, props.auth.token);
    
    return(
        <div>
            <div className="member-list">
                {
                    !isLoading && members !== false && members.map((member) => (
                        <div className="member-list-wrapper" key={member.UserID}>
                            <MemberCard1 member={member} buttons={props.buttons}/>
                        </div>
                    ))
                }
                {
                    isLoading && <div className="member-list-wrapper"><span className="skeleton"></span></div>
                }
            </div>
            {
                !isLoading && !_.isUndefined(parameter) && total > 0 &&
                <PaginationWrapper
                    className="mt-4"
                    activePage={parameter.paged}
                    itemsCountPerPage={parameter.posts_per_page}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setParameter(update(parameter, { paged : {$set : pagenumber } }))
                    }}
                />   
            }
        </div>
    )
});

const MemberList2 = connect(stateMap)((props) => {
    
    const [parameter, setParameter] = useState( props.membersArgs );

    useEffect(() => {

        setParameter(props.membersArgs);

    }, [props.membersArgs]);

    const {members, total, isLoading} = useMemberList(parameter, props.auth.token);

    return (
        <div className="member-list-2">
            <ul className="the-members">
                {
                    isLoading &&
                    <li className="the-member">
                        <span className="skeleton"></span>
                    </li>
                }
                {
                    !isLoading && members !== false && members.length > 0 && members.map((member) => (
                        <li className="the-member" key={member.UserID}>
                            <span className="avatar circle">
                                <AvatarVertical1 user={member}/>
                            </span>
                        </li>
                    ))
                }{
                    !isLoading && members !== false && members.length === 3 && total > 3 &&
                    <li className="the-member member-count">
                        +{ parseInt(total) - members.length }
                    </li>
                }
                
            </ul>
        </div>
    )
});

const MemberSlider = (props) => {
    
    const [Members] = useState(props.members);
    
    return(
        <div className="member-sliders">
            <Splide options={{
                autoWidth : true
                ,pagination : false
                ,arrows : false
            }}>
                {
                    Members.map((Member) => (
                        <SplideSlide key={Member.UserID}>

                        </SplideSlide>
                    ))
                }
            </Splide>
        </div>
    )
}


export {MemberSlider, MemberList, MemberList2}